import type { Options } from 'juice';

/**
 * juice >= 10 resolves CSS variables by default, and reads `prop.prop.indexOf('--')`
 * without a guard. A declaration missing its colon (`p{color;font-size:12px}`) parses
 * to a property with no name, so inlining any email containing one throws — which is
 * how sending a transcript broke in production on 2026-08-04. Still unguarded in
 * juice 12; keep this off until upstream fixes it.
 */
export const juiceOptions: Options = {
  resolveCSSVariables: false,
};
